import { motion } from "framer-motion";
import { useI18n } from "@/i18n";

interface TipCalloutProps {
  text: string;
}

export function TipCallout({ text }: TipCalloutProps) {
  const { t } = useI18n();

  return (
    <motion.div
      initial={{ opacity: 0, x: -8 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.4, ease: "easeOut" }}
      className="flex gap-3 px-4 py-3 bg-kra-soft/60 rounded-xl border border-kra-light/30"
    >
      <div className="flex-shrink-0 mt-0.5">
        <div className="w-5 h-5 rounded-full bg-kra/10 flex items-center justify-center">
          <svg className="w-3 h-3 text-kra" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
      </div>
      <div>
        <span className="text-[10px] font-semibold uppercase tracking-wider text-kra-dark/70">
          {t.common.tip}
        </span>
        <p className="text-sm text-ink-1 leading-relaxed mt-0.5">{text}</p>
      </div>
    </motion.div>
  );
}
